import AdditionalField from "@CheckOrder/features/TicketAdditionalInfo/components/AdditionalField";
import {
    TicketAdditionalInfoFieldsType
} from "@CheckOrder/features/TicketAdditionalInfo/types/TicketAdditionalInfoFields.type";

type AdditionalFieldsProps = {
    additionalInfoFields: TicketAdditionalInfoFieldsType[],
    index: number,
    userConfirmed: boolean,
    updateAllPassengers?: boolean,
    isReturn?: boolean
}

function PassengerAdditionalFields({additionalInfoFields, userConfirmed, index, updateAllPassengers, isReturn}: AdditionalFieldsProps) {
    return (
        <>
            {additionalInfoFields.map((field, fieldIndex) => (
                <AdditionalField
                    updateAllPassengers={updateAllPassengers}
                    /* eslint-disable-next-line react/no-array-index-key */
                    key={`${field.key}-${fieldIndex}`}
                    index={index}
                    userConfirmed={userConfirmed}
                    field={field}
                    isReturn={isReturn}
                />
            ))}
        </>
    );
}

export default PassengerAdditionalFields;